export default __webpack_public_path__ + "static/equipoMobile-148dc7086754c6017feac1972d40064d.png";